import { ClaimInfoHeader, ClaimInfoInsurerLogo } from "./ClaimInfoHeader";

export class NullClaimInfoHeader implements ClaimInfoHeader {

  init(): void {
    // do nothing
  }

  setInsurerLogo(_details: ClaimInfoInsurerLogo): void {
    // do nothing
  }

}
